import SmartPhoto from "../../plugins/smartphoto.min.js";

window.addEventListener('DOMContentLoaded',function(){
    new SmartPhoto(".js-smartPhoto");
});
